//React
import * as React from "react";

//React Router
import { Redirect } from "react-router-dom";

//React Components
import Checkbox from "material-ui/Checkbox";
import { FormControl, FormControlLabel } from "material-ui/Form";
import IconButton from "material-ui/IconButton";
import Input, { InputAdornment, InputLabel } from "material-ui/Input";
import Typography from "material-ui/Typography";

// Framework
import { getURLByEnv } from "../../framework/utils/URL";

//Icons
import AccountCircle from "material-ui-icons/AccountCircle";
import ErrorOutline from "material-ui-icons/ErrorOutline";
import Visibility from "material-ui-icons/Visibility";
import VisibilityOff from "material-ui-icons/VisibilityOff";

//Components
import Button from "material-ui/Button";

//Managers
import * as ColorManager from "./../../managers/ColorManager";
import { NetworkManager } from "./../../managers/NetworkManager";
import { StyleManager } from "./../../managers/StyleManager";

//Style
const styles = StyleManager.getStyles().LoginView;

interface LoginState {
    connected: boolean;
    error: string;
    password: string;
    rememberMe: boolean;
    showPassword: boolean;
    username: string;
}

/**
 * @description Contain the Login View
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class Login
 * @extends {React.Component}
 */
export default class Login extends React.Component<{}, LoginState> {

    /**
     * Creates an instance of Login.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Login
     */
    constructor(props) {
        super(props);
        this.state = {
            connected: false,
            error: "",
            password: "",
            rememberMe: false,
            showPassword: false,
            username: ""
        };
    }

    /**
     * @description Component is now mounted in the App
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof Login
     */
    componentDidMount() {
        this.setState({
            connected: Boolean(NetworkManager.getUserCredentials())
        });
    }

    /**
     * @description Change a property in the state
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof Login
     */
    handleChange = (prop) => (event) => {
        this.setState({ [prop]: event.target.value } as any);
    }

    /**
     * @description Block the mouse down event
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof Login
     */
    handleMouseDownPassword = (event) => {
        event.preventDefault();
    }

    /**
     * @description Show/Hide the input password value
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof Login
     */
    handleClickShowPasssword = () => {
        this.setState({
            showPassword: !this.state.showPassword
        });
    }

    /**
     * @description Modify the value of the rememberMe checkbox
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof Login
     */
    handleClickRememberMe = () => {
        this.setState({
            rememberMe: !this.state.rememberMe
        });
    }

    /**
     * @description Try to connect the User to the
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof Login
     */
    async connect() {
        if (this.state.username === "" || this.state.password === "") {
            this.setState({ error: "Veuillez renseigner tous les champs du formulaire." });
        } else {
            this.setState({ error: "" });
            const connexion = await NetworkManager.connect(this.state.username, this.state.password, this.state.rememberMe);
            if (connexion === true) {
                this.setState({ connected: true });
            } else {
                this.setState({ error: connexion.error });
            }
        }
    }

    /**
     * @description Render the Login View
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns Login View
     * @memberof Login
     */
    render() {
        if (this.state.connected) {
            return (<Redirect to={`${getURLByEnv()}/home`} />);
        }

        return (
            <div style={styles.formContainer}>
                {/* Title of the View */}
                <Typography type="display1" gutterBottom align="center" style={{
                    color: ColorManager.default.primaryColor,
                    textAlign: "center"
                }}>Connexion</Typography>

                {/* Username Field */}
                <FormControl style={styles.inputContainer}>
                    <InputLabel>Nom d'utilisateur</InputLabel>
                    <Input
                        value={this.state.username}
                        onChange={this.handleChange("username")}
                        endAdornment={< InputAdornment position="end" > <IconButton><AccountCircle /></IconButton> </InputAdornment>} />
                </FormControl>

                {/* Password Field */}
                <FormControl style={styles.inputContainer}>
                    <InputLabel htmlFor="password">Mot de passe</InputLabel>
                    <Input
                        type={this.state.showPassword
                            ? "text"
                            : "password"}
                        value={this.state.password}
                        onChange={this.handleChange("password")}
                        endAdornment={< InputAdornment position="end" > <IconButton
                            onClick={this.handleClickShowPasssword}
                            onMouseDown={this.handleMouseDownPassword}>
                            {this.state.showPassword
                                ? <VisibilityOff />
                                : <Visibility />}
                        </IconButton> </InputAdornment>} />
                </FormControl>

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={this.state.rememberMe}
                            onChange={this.handleClickRememberMe}
                        />
                    }
                    label="Se souvenir de moi"
                />

                <Button raised style={styles.loginButton} onClick={() => this.connect()}>Connexion</Button>

                {/* Show errors */}
                {
                    this.state.error !== "" ?
                        <Typography type="body2" align="center" style={styles.errorMessage}><ErrorOutline /> {this.state.error} </Typography>
                        : ""
                }
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/UI/views/Login.tsx